export enum CoveragesDrawerParams {
  ClaimId = 'claimId',
}
